
export const useUserInfo = (): { name: string } => {
  return JSON.parse(localStorage.getItem("user-info") || "null");
};
